export default __webpack_public_path__ + "static/media/MusicalIntruments_39.867ef568.png";